import React from 'react';

import { Header, Slider, Footer } from '@/components/Template/Template2';
import { Section } from '@/components/global/Section';

import { TRecommendation } from '@/services/requests/Recommendation/types/template2';

import { getLayoutClass } from '@/helpers/HtmlHelper/getLayoutClass';

type TTemplateVitrine2Props = {
  data: TRecommendation[];
};

const TemplateVitrine2 = ({ data }: TTemplateVitrine2Props) => {
  const { layout } = data[0];

  return (
    <Section className={getLayoutClass('2', layout)} data={data}>
      <div className="vitrine-template2__container">
        <Header data={data[0]} />
        <Slider data={data[0]} />
        <Footer data={data[0]} />
      </div>
    </Section>
  );
};

export default TemplateVitrine2;
